import React from 'react';
import useConversation from './useConversation';
import closeButtonImage from '../close.jpg';

const Chat = ({ socket, currentUser, closeChat, partnerId }) => {
  const { messages, draft: newMessage, setDraft: setNewMessage, send: sendMessage, error, sending, reload } = useConversation({ socket, userId: currentUser.id, partnerId });

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      sendMessage();
    }
  };

  return (
    <div className='chat-container'>
      <div className="chat-header">
        <h3>צ׳אט</h3>
        <button onClick={closeChat} className="close-chat-button">
          <img src={closeButtonImage} alt="סגירה" />
        </button>
      </div>
      <div className="chat-messages">
        {messages.map((msg) => (
          <div key={msg.id} className={`message ${msg.sender_id === currentUser.id ? 'sent' : 'received'}`}>
            <div className="message-text">{msg.text}</div>
            <div className="message-time">
              {msg.timestamp ? new Date(msg.timestamp).toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit' }) : ''}
            </div>
          </div>
        ))}
        {messages.length === 0 && <p className="no-messages">עדיין אין הודעות. זה הזמן להגיד שלום!</p>}
      </div>
      {error && <div role="alert" className="inline-error">{error} <button onClick={reload}>טעינת השיחה מחדש</button></div>}
      <div className="chat-input">
        <input
          type="text"
          aria-label="הודעה"
          maxLength={500}
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="כתבו הודעה…"
        />
        <button onClick={sendMessage} disabled={sending || !newMessage.trim()}>{sending ? 'שולחים…' : "שליחה"}</button>
      </div>
    </div>
  );
};

export default Chat;
